class Controller {
  constructor() {
    "ngInject";

    this.items = [];
  }

  addToItems(item) {
    this.items.push(item);
  }

  removeFromItems(item) {
    const index = this.items.indexOf(item);
    this.items.splice(index, 1);
  }

  closeAll(accordion) {
    this.items.forEach((item) => {
      if (item !== accordion) {
        item.contentShow = false;
        item.hideContent();
      }
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/accordionGroup/accordionGroup.controller.js